function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDispute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hnm0kwstda"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9088",
    transform: "translate(932 756)",
    style: {
      fill: "#fff",
      stroke: "#707070"
    },
    d: "M0 0h32v32H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 209",
    transform: "translate(-932 -756)",
    style: {
      clipPath: "url(#hnm0kwstda)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10256"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10255"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Polygon 46",
    style: {
      fill: "#00a6c2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.262 29.65H6.938a3.217 3.217 0 0 1-2.816-1.627 3.217 3.217 0 0 1 .003-3.251L14.787 6.355A3.217 3.217 0 0 1 17.6 4.733c1.173 0 2.225.607 2.813 1.622l10.662 18.417c.589 1.017.59 2.233.003 3.251a3.217 3.217 0 0 1-2.816 1.627z",
    style: {
      stroke: "none"
    },
    transform: "translate(930.4 755.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 5.483c-.903 0-1.711.467-2.164 1.248L4.774 25.147a2.474 2.474 0 0 0-.002 2.502A2.474 2.474 0 0 0 6.938 28.9h21.324c.905 0 1.714-.468 2.166-1.251a2.474 2.474 0 0 0-.002-2.502L19.764 6.731A2.475 2.475 0 0 0 17.6 5.483m0-1.5c1.346 0 2.691.666 3.462 1.996l10.662 18.417c1.544 2.667-.38 6.004-3.462 6.004H6.938c-3.082 0-5.006-3.337-3.462-6.004L14.138 5.979A3.963 3.963 0 0 1 17.6 3.983z",
    style: {
      fill: "#283045",
      stroke: "none"
    },
    transform: "translate(930.4 755.2)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Polygon 47",
    style: {
      fill: "#faf871"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.537 20.05H3.463c-.452 0-.857-.234-1.083-.625a1.237 1.237 0 0 1 0-1.25l8.537-14.797c.226-.392.63-.626 1.083-.626.452 0 .857.234 1.083.626l8.537 14.797c.226.392.226.859 0 1.25s-.631.625-1.083.625z",
    style: {
      stroke: "none"
    },
    transform: "translate(936 761.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.502a.484.484 0 0 0-.433.25L3.03 18.55a.484.484 0 0 0 0 .5c.054.093.182.25.433.25h17.074c.251 0 .38-.157.433-.25a.484.484 0 0 0 0-.5L12.433 3.752a.484.484 0 0 0-.433-.25m0-1.5c.674 0 1.348.334 1.732 1l8.538 14.799c.769 1.333-.194 2.999-1.733 2.999H3.463c-1.54 0-2.502-1.666-1.733-3l8.538-14.797c.384-.667 1.058-1 1.732-1z",
    style: {
      fill: "#283045",
      stroke: "none"
    },
    transform: "translate(936 761.6)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10254"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46851",
    d: "M-587.245 1216.953a.988.988 0 0 1-.967-1.094v-4.628a.971.971 0 0 1 .715-1c.082-.023.167-.033.251-.049v.015a.26.26 0 0 1 .053.211v6.323a.277.277 0 0 1-.052.212z",
    transform: "translate(1535.412 -440.578)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46852",
    d: "M-587.1 1403.679a.969.969 0 0 1-.95-.834.953.953 0 0 1 .809-1.081c.047-.006.094-.019.141-.029v.014a.26.26 0 0 1 .053.211v1.493a.277.277 0 0 1-.052.212z",
    transform: "translate(1535.268 -624.406)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46853",
    d: "M-564.312 1217.268v-6.747a.953.953 0 0 1 .966.93c.005.74 0 1.479 0 2.219v2.67a.941.941 0 0 1-.966.928z",
    transform: "translate(1512.477 -440.906)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46854",
    d: "M-564.312 1403.993v-1.916a.957.957 0 0 1 .968.959.946.946 0 0 1-.968.957z",
    transform: "translate(1512.477 -624.733)",
    style: {
      fill: "#283045"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispute);
export default __webpack_public_path__ + "static/media/Dispute.6f44efe3b44fee5f66f39e1fc13fa3a0.svg";
export { ForwardRef as ReactComponent };